import React from 'react';
import dayjs from 'dayjs';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ReactComponent as MasterCard } from 'assets/icons/mastercard-card.svg';
import { ReactComponent as Visa } from 'assets/icons/visa-card.svg';
import { ReactComponent as UnionPay } from 'assets/icons/unionpay-card.svg';
import { ReactComponent as Amex } from 'assets/icons/amex-card.svg';
import sepaPath from 'assets/images/sepa.png';
import { Typography } from '@mui/material';
import { Wrapper } from './PaymentMethod.styles';
import { neutrals } from 'utils/styles/color';
import { useWindowDimensions } from 'pages/AuthPage/AuthPage';

type PaymentMethodProps = {
  method: PMethod;
};

const PaymentMethod = ({ method }: PaymentMethodProps) => {
  const { width } = useWindowDimensions();

  let name = '';
  let last4 = '';
  let image = <></>;
  let expire = '';

  if (method.paymentMethod === 'card') {
    name = method.creditCardInfo.brand;
    last4 = method.creditCardInfo.last4;
    expire = `Expires ${dayjs(
      `${method.creditCardInfo.expire_year}-${method.creditCardInfo.expire_month}`
    ).format('MMM YYYY')}`;
    if (method.creditCardInfo.brand === 'visa') {
      image = <Visa />;
    } else if (method.creditCardInfo.brand === 'mastercard') {
      image = <MasterCard />;
    } else if (method.creditCardInfo.brand === 'amex') {
      image = <Amex />;
    } else if (method.creditCardInfo.brand === 'unionpay') {
      image = <UnionPay />;
    }
  } else if (method.paymentMethod === 'ach_debit') {
    name = method.banckAccountInfo.bank_name;
    last4 = method.banckAccountInfo.last4;
    image = <AccountBalanceIcon sx={{ color: neutrals[700] }} />;
  } else if (method.paymentMethod === 'acss_debit') {
    name = method.banckAccountInfo.bank_name;
    last4 = method.banckAccountInfo.last4;
    image = <AccountBalanceIcon sx={{ color: neutrals[700] }} />;
  } else if (method.paymentMethod === 'sepa_debit') {
    name = 'SEPA';
    last4 = method.banckAccountInfo.last4;
    image = <img src={sepaPath} alt="SEPA payment" />;
  }

  return (
    <Wrapper>
      {image}
      <div className="payment-option-info">
        <Typography
          variant="body1"
          fontSize="0.875rem"
          fontWeight={width < 600 ? 400 : 500}
        >
          {name} &bull;&bull;&bull;&bull; {last4}
        </Typography>
        <Typography variant="body2" fontWeight={width < 600 ? 400 : 500}>
          {expire}
        </Typography>
      </div>
    </Wrapper>
  );
};

export default PaymentMethod;
